@if (isLoading()) {
  <div class="loader-container">
    <div class="card border shadow shadow-md m-0 p-2">
      <div class="loading-wave" role="status">
        <div class="loading-bar"></div>
        <div class="loading-bar"></div>
        <div class="loading-bar"></div>
        <div class="loading-bar"></div>
      </div>
      <span class="text-center cargando">Cargando ...</span>
    </div>
  </div>
}
